const currentProfile = (state = {}, action) =>
  action.type === "CURRENT_PROFILE" ? action.payload : state
export default currentProfile
